// extracted by mini-css-extract-plugin
export default {"root":"Button_root__8rhsz","primary":"Button_primary__LeT2a","active":"Button_active__xAPNN","secondary":"Button_secondary__YE5cU","danger":"Button_danger__Fz734"};